<template>
    <div v-if="displayDiscountTitle || displayOdrTitle || displayMobileBonusRecoveryText" class="bg-greige px-1 advantage-bloc-padding font-weight-bold small">
        <!--/* Promo */-->
        <div class="py-0">
            {{ displayDiscountTitle }}
        </div>
        <!--/* Odr */-->
        <div class="py-0">
            {{ displayOdrTitle }}
        </div>
        <!--/* bonus reprise */-->
        <div class="py-0">
            {{ displayMobileBonusRecoveryText }}
        </div>
    </div>
</template>

<script>

export default {
    props: {
        advantageMessages: {
            type: Object,
            required: true
        },
        bonusRecovery: {
            type: Number,
            required: false,
            default: null
        },
        odr: {
            type: Number,
            required: false,
            default: null
        },
        discount: {
            type: Number,
            required: false,
            default: null
        },
    },
    computed: {
        displayDiscountTitle() {
            return this.discount ? this.advantageMessages.discount.replace("{0}", PriceFormatter.formatEurosWithSpace(this.discount / 100, false).toString()) : ""
        },
        displayOdrTitle() {
            return this.odr ? this.advantageMessages.odr.replace("{0}", PriceFormatter.formatEurosWithSpace(this.odr / 100, false).toString()) : ""
        },
        displayMobileBonusRecoveryText() {
            if (this.bonusRecovery) {
                return this.advantageMessages.bonusRecovery.replace("{0}", PriceFormatter.formatEurosWithSpace(this.bonusRecovery / 100, false).toString())
            } else {
                return null
            }
        }
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_common';

.advantage-bloc-padding {
    padding-top: px-to-rem(10);
    padding-bottom: px-to-rem(10);
}

</style>
